function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
module.exports = function (priceTaxFeeAdjusterBase, clone) {
  var priceTaxFeeAdjuster = /*#__PURE__*/function (_priceTaxFeeAdjusterB) {
    function priceTaxFeeAdjuster(supplementalData) {
      var _this;
      _classCallCheck(this, priceTaxFeeAdjuster);
      _this = _callSuper(this, priceTaxFeeAdjuster, [supplementalData]);
      _this.name = 'ebt';
      _this.id = priceTaxFeeAdjuster.nextId;
      if (!supplementalData.dryrun) {
        priceTaxFeeAdjuster.nextId++;
      }
      _this.supplementalData = supplementalData;
      // EBT is pre-tax:
      _this.priority = priceTaxFeeAdjuster.taxPriority + 300;
      return _this;
    }
    _inherits(priceTaxFeeAdjuster, _priceTaxFeeAdjusterB);
    return _createClass(priceTaxFeeAdjuster, [{
      key: "calculate",
      value: function calculate(productlist) {
        var _this2 = this;
        var skipEbtCheck = this.supplementalData.allebt;
        var balance = this.supplementalData.balance;
        /*
         * this priceTaxFeeAdjuster is only applied up until the last product present when the card
         * that triggered it was swiped and only on EBT products
         */
        var ebtProductlist = productlist.slice(0, this.supplementalData.purchaseLinePosition).filter(function (a) {
          return typeof a.upc !== 'undefined' && !a.isFree && !(a.priceTaxFeeAdjustments && a.priceTaxFeeAdjustments.find(function (b) {
            return b.name === 'ewic';
          })) && (skipEbtCheck || a.isebt);
        });
        /*
         * we will want to process taxable products first so we also get their tax cancelled as EBT
         * cancels tax on products
         */
        var ebtProductlistSortedByTax = ebtProductlist.sort(function (a, b) {
          return a.refund === b.refund ? Math.sign(b.tax - a.tax) : Math.sign(b.refund - a.refund);
        }); // "tax true" should return less than "tax false" so it appears higher in the list

        /*
         * splice out all priceTaxFeeAdjustments of the type that this function will create before
         * recalc otherwise we'll get two with the same name/id
         */
        var _iterator = _createForOfIteratorHelper(ebtProductlistSortedByTax),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var p = _step.value;
            if (p.priceTaxFeeAdjustments) {
              p.priceTaxFeeAdjustments = p.priceTaxFeeAdjustments.filter(function (a) {
                return !(a.name === _this2.name && a.id === _this2.id);
              });
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        var _iterator2 = _createForOfIteratorHelper(ebtProductlistSortedByTax),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var _p = _step2.value;
            /*******************************************************************************************
             * we do this here and not at the start of the function for two reasons -
             * 1. we may have needed to adjust balance to 0 e.g. for cancelling ebt and we want to be
             * able to splice out all the ebt adjusters
             * 2. we anyways need to check it after every loop to see if we still have enough balance to
             * discount another product
             ******************************************************************************************/
            if (!balance) {
              return true;
            }

            /*
             * we must split price and fee tax as depending on if and how much EBT balance was present
             * to cover also the fee, the fee-tax also gets proportionally discounted IntPricelist
             * already includes refund co-efficient so we need to remove it because refund is calculated
             * later when this function returns and must not intervene here
             */
            var productNetPriceTaxFee = {
              price: (_p.refund ? -1 : 1) * _p.intPrice,
              tax: {
                price: 0,
                fee: 0
              },
              fee: 0
            };
            if (_p.priceTaxFeeAdjustments) {
              var feebusterPtf = _p.priceTaxFeeAdjustments.find(function (a) {
                return a.name === 'feebuster';
              });
              var _loop = function _loop(field) {
                  if (field === 'tax') {
                    var priceTax = _p.priceTaxFeeAdjustments.filter(function (a) {
                      return !a.extra || !a.extra.totalTaxableFees;
                    }).reduce(function (total, a) {
                      return total + a.tax;
                    }, 0);
                    var feeTax = _p.priceTaxFeeAdjustments.filter(function (a) {
                      return a.extra && a.extra.totalTaxableFees;
                    }).reduce(function (total, a) {
                      return total + a.tax;
                    }, 0);
                    productNetPriceTaxFee.tax.price += priceTax;
                    productNetPriceTaxFee.tax.fee += feeTax;
                  } else {
                    if (field === 'price' && feebusterPtf) {
                      priceTaxFeeAdjustmentsToUse = feebusterPtf.extra.cashPrice.priceTaxFeeAdjustments;
                    } else {
                      priceTaxFeeAdjustmentsToUse = _p.priceTaxFeeAdjustments;
                    }
                    productNetPriceTaxFee[field] += priceTaxFeeAdjustmentsToUse.reduce(function (total, a) {
                      return total + a[field];
                    }, 0);
                    var existingEbtPtfs = _p.priceTaxFeeAdjustments.filter(function (a) {
                      return a.name === 'ebt';
                    });
                    if (existingEbtPtfs.length) {
                      var existingRedemption = existingEbtPtfs.reduce(function (t, v) {
                        return t + v.extra.redemption[field];
                      }, 0);
                      productNetPriceTaxFee[field] += existingRedemption;
                    }
                  }
                },
                priceTaxFeeAdjustmentsToUse,
                priceTaxFeeAdjustmentsToUse;
              for (var field in productNetPriceTaxFee) {
                _loop(field);
              }
            }

            /*
             * although the total EBT redemption on the basket is a payment and not a price adjuster,
             * the redemption amount per product is required for storing the taxable amount in the DB
             * and for ebt reports
             */
            var priceTaxFeeAdjustment = {
              name: this.name,
              id: this.id,
              priority: this.priority,
              price: 0,
              tax: 0,
              fee: 0,
              extra: {
                redemption: {
                  price: 0,
                  fee: 0
                }
              }
            };

            // Calculation for discount on Price component
            /*
             * the least of the two in case there is not enough balance for a full discount
             * unless it's a refund in which case a credit is always welcome
             */
            var ebtPriceDiscountForThisProduct = _p.refund ? productNetPriceTaxFee.price : Math.min(productNetPriceTaxFee.price, balance);
            if (this.supplementalData.dryrun) {
              priceTaxFeeAdjustment.price -= ebtPriceDiscountForThisProduct;
            } else {
              priceTaxFeeAdjustment.extra.redemption.price -= ebtPriceDiscountForThisProduct;
            }

            // adjust balance as EBT is redeemed; a refund causes balance to increase
            balance -= (_p.refund ? -1 : 1) * ebtPriceDiscountForThisProduct;

            // Calculation for discount on Fee component
            /*
             * fee is paid out of ebt funds just like any purchase and for EBT purposes counts as
             * another purchase item
             */
            var ebtFeeDiscountForThisProduct = _p.refund ? productNetPriceTaxFee.fee : Math.min(productNetPriceTaxFee.fee, balance);
            if (this.supplementalData.dryrun) {
              priceTaxFeeAdjustment.fee -= ebtFeeDiscountForThisProduct;
            } else {
              priceTaxFeeAdjustment.extra.redemption.fee -= ebtFeeDiscountForThisProduct;
            }
            balance -= (_p.refund ? -1 : 1) * ebtFeeDiscountForThisProduct;

            // all tax on the part that was paid for by EBT is refunded
            var netPriceTax = productNetPriceTaxFee.price ? ebtPriceDiscountForThisProduct / productNetPriceTaxFee.price * productNetPriceTaxFee.tax.price : 0;
            var netFeeTax = productNetPriceTaxFee.fee ? ebtFeeDiscountForThisProduct / productNetPriceTaxFee.fee * productNetPriceTaxFee.tax.fee : 0;
            var totalEbtTaxDiscountForThisProduct = netPriceTax + netFeeTax;
            priceTaxFeeAdjustment.tax -= totalEbtTaxDiscountForThisProduct;
            _p.priceTaxFeeAdjustments = _p.priceTaxFeeAdjustments || [];
            _p.priceTaxFeeAdjustments.push(priceTaxFeeAdjustment);
            var totalRedemption = _p.priceTaxFeeAdjustments.filter(function (a) {
              return ['ebt', 'ewic'].includes(a.name);
            }).reduce(function (total, a) {
              return total + a.price + a.extra.redemption.price;
            }, 0);
            /*
             * any redemption on a line item removes feebuster - to avoid really complicated
             * calculations no need to worry about multi-qty lines as they are split in
             * payment.service.js so at worst we lose feebuster on a fraction of an item if the split
             * left fractions we have to emulate having set ebt on an item without the added feebuster
             * fee - but feebuster comes earlier so the only way is to calculate then copy the
             * cash-price-item's PTFs back up to the parent item and we can only copy the child ptf
             * after we have calculated it so we can't do it in the first loop
             */
            if (totalRedemption) {
              if (_p.cashPrice) {
                // child feebuster item
                var parentItem = _p.source;
                var parentFeebusterPtf = parentItem.priceTaxFeeAdjustments.find(function (a) {
                  return a.name === 'feebuster';
                });
                parentItem.priceTaxFeeAdjustments = clone(_p.priceTaxFeeAdjustments);
                parentItem.priceTaxFeeAdjustments.push(parentFeebusterPtf);
              } else {
                // parent feebuster item
                var _feebusterPtf = _p.priceTaxFeeAdjustments.find(function (a) {
                  return a.name === 'feebuster';
                });
                if (_feebusterPtf) {
                  // set it to 0 price but don't remove it or you lose the child feebuster PTF!
                  _feebusterPtf.price = 0;
                }
              }
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
    }]);
  }(priceTaxFeeAdjusterBase);
  priceTaxFeeAdjuster.nextId = 0;
  // so positive priorities are post-tax adjusters and negative values are pre-tax
  priceTaxFeeAdjuster.taxPriority = 0;
  return {
    priceTaxFeeAdjuster: priceTaxFeeAdjuster
  };
}(require('../base.js'), require('clone'));